import styled from 'styled-components';

import Marker from './Marker';

const StyledMarker = styled(Marker)`
    position: relative;

    height: 3rem;
    width: 2.125rem;
    transform: translate(-50%, -100%);

    &[data-active='true'] {
        z-index: 999;
    }

    .marker {
        height: 3rem;
        width: 2.125rem;
        object-fit: contain;
    }

    .popover {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        opacity: 0;
        pointer-events: none;
        background-color: ${(props) => props.theme.colours.white};
        width: 256px;
        border-radius: 1rem;
        box-shadow: 0 4px 16px 0 ${(props) => props.theme.colours.black}40;
        transition: transform 150ms ease, opacity 150ms ease;

        &-link {
            height: 100%;
            width: 100%;
            text-decoration: none;

            &::before {
                content: '';
                display: none;
                position: absolute;
                height: 150%;
                width: 150%;
                top: -25%;
                left: -25%;
            }
        }

        &-img {
            width: 100%;
            max-height: 144px;
            object-fit: cover;
            border-radius: 1rem 1rem 0 0;
        }

        &-details {
            display: flex;
            flex-direction: row;
            padding: 1rem;
            align-items: flex-end;
            justify-content: space-between;
        }

        &-location {
            font-size: 1.5rem;
            color: ${(props) => props.theme.colours.primary};
            font-weight: 700;
            & > small {
                display: block;
                margin: 0.5rem 0 0;
                font-size: 1.25rem;
                color: ${(props) => props.theme.colours.black};
                font-weight: 400;
            }
        }

        &-close {
            display: flex;
            position: absolute;
            padding: 0.5rem;
            top: 0.75rem;
            right: 0.75rem;
            justify-content: center;
            align-items: center;
            background: none;
            border: 2px solid ${(props) => props.theme.colours.white};
            transform: rotate(45deg);
            cursor: pointer;
            border-radius: 50%;
            height: 32px;
            width: 32px;

            svg path {
                transition: fill 100ms ease;
                fill: ${(props) => props.theme.colours.white};
            }

            &:hover {
                svg path {
                    fill: ${(props) => props.theme.colours.secondary};
                }
            }
        }

        &-price {
            font-size: 1rem;
            margin: 0 0 0 1rem;
            text-align: right;
        }

        &-price-value {
            display: block;
            font-size: 2rem;
            color: ${(props) => props.theme.colours.secondary};
            font-weight: 700;
            margin: 0.5rem 0 0;
        }
    }

    &[data-active='true'] .popover {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
        pointer-events: all;
    }

    &[data-fixed='true'] .popover-link::before {
        display: block;
    }
`;

export default StyledMarker;
